<template>
  <div class="contracts">
    <template v-if="accountTypeI === ACCOUNT_TYPES.notVerified">
      <div class="md-layout-item
                  md-size-50
                  md-medium-size-65
                  md-small-size-95
                  md-xsmall-size-100
                  contracts__not-available-description">
        <not-available-card icon='work'
                          :title="i18n.lbl_not_available()"
                          :descr="i18n.lbl_contracts_not_available_exp()"
                          />
      </div>
    </template>
    <template v-else>
      <md-tabs md-dynamic-height v-if="!showDetails">
        <md-tab :md-label="`${ i18n.cont_signed()}`">
          <signed-list @open-details="openDetails"/>
        </md-tab>
        <md-tab :md-label="`${ i18n.cont_new_contract()}`"
                v-if="accountTypeI === ACCOUNT_TYPES.syndicate">
          <new-contract />
        </md-tab>
        <md-tab :md-label="`${ i18n.cont_signature_requests()}`">
          <requests-list @open-details="openDetails"/>
        </md-tab>
        <md-tab :md-label="`${ i18n.lbl_archive()}`">
          <archived-list @open-details="openDetails"/>
        </md-tab>
      </md-tabs>
      <template v-else>
        <contract-details :id="requestId" :type="detailsType" @close-details="showDetails = false" />
      </template>
    </template>
  </div>
</template>

<script>
import SignedList from './signed/Contracts.SignedList'
import ArchivedList from './archive/Contracts.ArchivedList'
import RequestsList from './requests/Contracts.RequestsList'
import NewContract from './new/Contracts.CreateNew'
import ContractDetails from './Contracts.Details'
import NotAvailableCard from '@vue/app/common/NotAvailableCard'
import { i18n } from '@js/i18n'
import { mapGetters } from 'vuex'
import { vuexTypes } from '@vuex/types'
import { ACCOUNT_TYPES } from '@const'

export default {
  components: {
    SignedList,
    NewContract,
    ArchivedList,
    RequestsList,
    ContractDetails,
    NotAvailableCard },
  data: _ => ({
    i18n,
    requestId: '',
    detailsType: '',
    showDetails: false,
    ACCOUNT_TYPES
  }),
  computed: {
    ...mapGetters([
      vuexTypes.accountTypeI
    ])
  },
  methods: {
    openDetails (opts) {
      this.requestId = opts.id
      this.detailsType = opts.type
      this.showDetails = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .md-tabs {
    margin: 1rem auto 0;
    // box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);
    max-width: $large;
  }

  .md-tab {
    padding: 0;
  }

  .contracts__not-available-description {
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/Contracts.Index.vue